import React from "react";
import "./Tooltip.css";

// Generic tooltip component. The "textClass" prop allows consumers to
// override the colour/style of the tooltip itself, while "containerClass"
// adjusts the wrapper that anchors the tooltip. Both are optional so the
// component can be reused for different visual variants across the app.
export function Tooltip({
  text,
  children,
  textClass = "",
  containerClass = "",
}) {
  return (
    <div className={`tooltip-container ${containerClass}`}>
      {children} {/* The button or any other element goes here */}
      <span className={`tooltip-text ${textClass}`}>{text}</span>
    </div>
  );
}